import React from 'react'

export const CoreContext = React.createContext(false)
